import {AfterViewInit, Component, inject, Input, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Router} from '@angular/router';
import {LoggerService} from '~core/utils/logger.service';
import {Paths} from '~core/security/auth.roles';
import {environment} from '~env/environment';
import {AuthService} from '~core/security/auth.service';
import {ConfigParametrosService} from '~core/api/config-parametros.service';
import {take} from 'rxjs/operators';
import {  Store } from '@ngrx/store';
import { AppConfigService } from '~core/background/app-config.service';
import { entityConfig } from '~ngrx/entitys/entity-configuracao/entity-configuracao.selectors';
import { getAuth } from '~ngrx/features/feature-auth/feature-auth.selectors';
import { IconRegistryService } from '~core/utils/icon-registry.service';
import { TranslateService } from '@ngx-translate/core';
import { VERSION } from '~env/version';
import { ChatNotificationsService } from '../../paginas/chat/chat-notifications.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss',
],
  providers: [ConfigParametrosService],
})
export class MenuComponent implements OnInit, AfterViewInit {

  @Input() menuOpened!: BehaviorSubject<string>;
  @Input() sidenavExpanse!: BehaviorSubject<boolean>;
  @Input() roles!: BehaviorSubject<{ [k: string]: boolean }>;
  @Input() alertesPadding!: number;


  description: string = environment.description;
  descriptionState!: Observable<string>;
  versaoState: Observable<string> = new BehaviorSubject(VERSION.version);
  hasLogoutRedirect: boolean = false;
  ativaReprogramacao?: boolean;

  GRID_PATH: string = Paths.GRID;
  MAPA_PATH: string = Paths.MAPA;
  ADMIN_VISITAS_PATH: string = Paths.ADMIN_VISITAS;
  ADMIN_CARREGAMENTO_PATH: string = Paths.ADMIN_CARREGAMENTO;
  DASHBOARD_PATH: string = Paths.DASHBOARD;
  CONFIG_PATH: string = Paths.CONFIG;
  FINANCEIRO_PATH: string = Paths.FINANCEIRO;
  CHAT_PATH: string = Paths.CHAT;
  TALKS_PATH: string = Paths.TALKS;
  ALERTAS_INCIDENTES_PATH: string = Paths.ALERTAS_INCIDENTES;
  REPROGRAMACAO: string = Paths.REPROGRAMACAO;
  RELATORIOS_PATH: string = Paths.RELATORIOS;

  showChat: boolean = environment.experimentalFeatures?.showChat || false;
  showTalkJs: boolean = environment.experimentalFeatures?.showTalkJs || false;
  showConfigGrupoUsuario: boolean = false;
  isAdmin:boolean = false;
  talkJsUnreadCount = 0;

  private readonly chatNotificationsService = inject(ChatNotificationsService);
  constructor(
    private readonly iconsService: IconRegistryService,
    private readonly router: Router,
    private readonly loggerService: LoggerService,
    private readonly authService: AuthService,
    private readonly store: Store,
    private readonly appConfig: AppConfigService,
    private readonly configParametrosService: ConfigParametrosService,
    private readonly translate: TranslateService) {
  }

  ngOnInit(): void {
    this.iconsService.setUp();
    this.store.select(getAuth).pipe(take(1)).subscribe(a => this.isAdmin = a.roles.includes('Admin'));
    this.store.select(entityConfig(this.appConfig.empresa))
      .subscribe(list => {
        this.showConfigGrupoUsuario = list.utilizaGrupoUsuario;
      });
    this.hasLogoutRedirect = !!environment.logoutRedirectSession && !!sessionStorage.getItem(environment.logoutRedirectSession);
    this.descriptionState = this.translate.get(this.description);
    this.chatNotificationsService.unreadCount$.subscribe(count => {
      this.talkJsUnreadCount = count;
    });
  }

  ngAfterViewInit(): void {
    this.configParametrosService.getParametros().pipe(take(1)).subscribe(params => {
      this.ativaReprogramacao = params.ativaReprogramacao;
    });
  }

  logoutRedirect(): void {
    this.authService.desativar(true);
  }

  irParaUrl(url: string): void {
    this.router.navigateByUrl(url).catch(e => this.loggerService.error('Não foi possivel navegar', e));
  }

  checkRoles(path: string, roles: { [k: string]: boolean } | null): boolean {
    return !!roles && roles[path];
  }

}
